import React, { useEffect } from 'react';
import CoinShopPage from './CoinShopPage';
import './CoinShopModal.css';

const CoinShopModal = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="coin-shop-modal-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="coin-shop-modal" onClick={(e) => e.stopPropagation()}>
        <button
          className="coin-shop-modal-close"
          type="button"
          onClick={onClose}
          aria-label="Close coin shop"
        >
          ×
        </button>
        <CoinShopPage />
      </div>
    </div>
  );
};

export default CoinShopModal;

